<template>
    <div v-if="series[0].data.length > 0">
        <apexchart type="bar"  width="100%" :options="currency ? chartOptionsCurrency : chartOptions" :series="series"></apexchart>
    </div>
</template>
<script>
    export default {
        props:['activeType', 'chart', 'categories', 'seriesToChart', 'currency'],
        data:() => {
            return{
                types:[
                    {
                        text: 'All time',
                        type: 'all'
                    },
                    {
                        text: 'This Year',
                        type: 'year'
                    },
                    {
                        text: 'This week',
                        type: 'week'
                    },
                    {
                        text: 'Today',
                        type: 'today'
                    }
                ],
                timeout:false,
                chartOptions: {
                    plotOptions: {
                        bar: {
                            borderRadius: 6,
                            columnWidth: '25%',
                            startingShape: 'rounded',
                            endingShape: 'rounded',
                        }
                    },
                    tooltip: {
                        custom: function({series, seriesIndex, dataPointIndex, w}) {
                            return '<div class="arrow_box">' +
                                '<span>'+series[0][dataPointIndex]+' new users</span>' +
                                '</div>'
                        },
                        followCursor: false,
                    },
                    chart: {
                        id: 'basic-bar',
                        toolbar:{
                            show: false,
                        },
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return '';
                            }
                        },
                        min: 0,
                        max: 100
                    },
                    xaxis: {
                        categories: []
                    },
                    dataLabels: {
                        enabled: false,
                    },

                    grid: {
                        xaxis: {
                            lines: {
                                show: false
                            }
                        },
                        yaxis: {
                            lines: {
                                show: false
                            }
                        }
                    }

                },
                chartOptionsCurrency: {
                    plotOptions: {
                        bar: {
                            borderRadius: 6,
                            columnWidth: '25%',
                            startingShape: 'rounded',
                            endingShape: 'rounded',
                        }
                    },
                    tooltip: {
                        custom: function({series, seriesIndex, dataPointIndex, w}) {
                            return '<div class="arrow_box">' +
                                '<span>'+series[0][dataPointIndex]+' AUD</span>' +
                                '</div>'
                        },
                        followCursor: false,
                    },
                    chart: {
                        id: 'basic-bar',
                        toolbar:{
                            show: false,
                        },
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return '';
                            }
                        },
                        min: 0,
                        max: 100
                    },
                    xaxis: {
                        categories: []
                    },
                    dataLabels: {
                        enabled: false,
                    },

                    grid: {
                        xaxis: {
                            lines: {
                                show: false
                            }
                        },
                        yaxis: {
                            lines: {
                                show: false
                            }
                        }
                    }

                },
                series: [{
                    data: []
                }]
            }
        },
        watch:{
              chart:{
                  deep:true,
                  handler: function () {
                      this.timeout = false;
                      this.setData();
                      setTimeout(() => {
                          this.timeout = true;
                      }, 100)
                  }
              }
        },
        mounted() {
            setTimeout(() => {
                this.timeout = true;
                this.setData();
            }, 50)
        },
        methods:{
            setData(){
                this.chartOptions.xaxis.categories = this.categories;
                let max = Math.max( ...this.seriesToChart );
                this.chartOptions.yaxis.max = max + Math.ceil(max*0.1);
                this.chartOptionsCurrency.yaxis.max = max + Math.ceil(max*0.1);
                this.series[0].data = this.seriesToChart;
            }
        }
    }
</script>
